import { styled } from '@mui/material/styles';
import { Grid, RadioGroup, CardActionArea } from '@mui/material';
import useSettings from '../../../hooks/useSettings';
import BoxMask from './BoxMask';
import IconifyIcon from 'src/components/icons/IconifyIcon';
import { IconifyIconEnum } from 'src/@types/icon';

const BoxStyle = styled(CardActionArea)(({ theme }) => ({
  height: 35,
  width: 60,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: theme.palette.text.disabled,
  border: `solid 1px ${theme.palette.grey[500_12]}`,
  margin: '0.5rem 0',
  borderRadius: Number(theme.shape.borderRadius) * 1.25,
}));

export default function SettingMode() {
  const { themeMode, onChangeMode } = useSettings();

  return (
    <RadioGroup name="themeMode" value={themeMode} onChange={onChangeMode}>
      <Grid dir="ltr" container>
        {['light', 'dark'].map((mode, index) => {
          const isSelected = themeMode === mode;

          return (
            <Grid
              key={mode}
              size={{ xs: 6 }}
              style={{ display: 'flex', justifyContent: 'space-around' }}
            >
              <BoxStyle
                sx={{
                  bgcolor: mode === 'light' ? 'common.white' : 'grey.800',
                  ...(isSelected && {
                    color: 'primary.main',
                    boxShadow: (theme) => theme.customShadows.z20,
                  }),
                }}
              >
                <IconifyIcon
                  icon={index === 0 ? IconifyIconEnum.Sun : IconifyIconEnum.Moon}
                  width={20}
                  height={20}
                />
                <BoxMask value={mode} />
              </BoxStyle>
            </Grid>
          );
        })}
      </Grid>
    </RadioGroup>
  );
}
